module.exports = __webpack_public_path__ + "img/Cagnoni.005a03c8.jpeg";